module.exports = __webpack_public_path__ + "img/Textured Lavender.b4a157ef.jpg";